// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDropContextProfileContext } from '../models/ApiDropContextProfileContext';
import { ApiDropGroupMention } from '../models/ApiDropGroupMention';
import { ApiDropMentionedUser } from '../models/ApiDropMentionedUser';
import { ApiDropMetadataResponse } from '../models/ApiDropMetadataResponse';
import { ApiDropNftLink } from '../models/ApiDropNftLink';
import { ApiDropPart } from '../models/ApiDropPart';
import { ApiDropRater } from '../models/ApiDropRater';
import { ApiDropReaction } from '../models/ApiDropReaction';
import { ApiDropReferencedNFT } from '../models/ApiDropReferencedNFT';
import { ApiDropSubscriptionTargetAction } from '../models/ApiDropSubscriptionTargetAction';
import { ApiDropType } from '../models/ApiDropType';
import { ApiDropWinningContext } from '../models/ApiDropWinningContext';
import { ApiMentionedWave } from '../models/ApiMentionedWave';
import { ApiProfileMin } from '../models/ApiProfileMin';
import { ApiReplyToDropResponse } from '../models/ApiReplyToDropResponse';
import { ApiWaveMin } from '../models/ApiWaveMin';
import { HttpFile } from '../http/http';

export class ApiDrop {
    'id': string;
    /**
    * Sequence number of the drop in Seize
    */
    'serial_no': number;
    'drop_type': ApiDropType;
    'rank': number | null;
    'winning_context'?: ApiDropWinningContext;
    'wave': ApiWaveMin;
    'reply_to'?: ApiReplyToDropResponse;
    'author': ApiProfileMin;
    /**
    * Time when the drop was created in milliseconds since 1-1-1970 00:00:00.0 UTC
    */
    'created_at': number;
    /**
    * Time when the drop was updated in milliseconds since 1-1-1970 00:00:00.0 UTC
    */
    'updated_at': number | null;
    'title': string | null;
    'parts': Array<ApiDropPart>;
    /**
    * Number of drops in the storm
    */
    'parts_count': number;
    'referenced_nfts': Array<ApiDropReferencedNFT>;
    'mentioned_users': Array<ApiDropMentionedUser>;
    'mentioned_groups': Array<ApiDropGroupMention>;
    'mentioned_waves': Array<ApiMentionedWave>;
    'metadata': Array<ApiDropMetadataResponse>;
    'rating': number;
    'realtime_rating': number;
    'rating_prediction': number;
    'top_raters': Array<ApiDropRater>;
    'raters_count': number;
    'context_profile_context': ApiDropContextProfileContext | null;
    'subscribed_actions': Array<ApiDropSubscriptionTargetAction>;
    'is_signed': boolean;
    'reactions': Array<ApiDropReaction>;
    'boosts': number;
    'hide_link_preview': boolean;
    'nft_links'?: Array<ApiDropNftLink>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "serial_no",
            "baseName": "serial_no",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "drop_type",
            "baseName": "drop_type",
            "type": "ApiDropType",
            "format": ""
        },
        {
            "name": "rank",
            "baseName": "rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "winning_context",
            "baseName": "winning_context",
            "type": "ApiDropWinningContext",
            "format": ""
        },
        {
            "name": "wave",
            "baseName": "wave",
            "type": "ApiWaveMin",
            "format": ""
        },
        {
            "name": "reply_to",
            "baseName": "reply_to",
            "type": "ApiReplyToDropResponse",
            "format": ""
        },
        {
            "name": "author",
            "baseName": "author",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "updated_at",
            "baseName": "updated_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "parts",
            "baseName": "parts",
            "type": "Array<ApiDropPart>",
            "format": ""
        },
        {
            "name": "parts_count",
            "baseName": "parts_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "referenced_nfts",
            "baseName": "referenced_nfts",
            "type": "Array<ApiDropReferencedNFT>",
            "format": ""
        },
        {
            "name": "mentioned_users",
            "baseName": "mentioned_users",
            "type": "Array<ApiDropMentionedUser>",
            "format": ""
        },
        {
            "name": "mentioned_groups",
            "baseName": "mentioned_groups",
            "type": "Array<ApiDropGroupMention>",
            "format": ""
        },
        {
            "name": "mentioned_waves",
            "baseName": "mentioned_waves",
            "type": "Array<ApiMentionedWave>",
            "format": ""
        },
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "Array<ApiDropMetadataResponse>",
            "format": ""
        },
        {
            "name": "rating",
            "baseName": "rating",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "realtime_rating",
            "baseName": "realtime_rating",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rating_prediction",
            "baseName": "rating_prediction",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "top_raters",
            "baseName": "top_raters",
            "type": "Array<ApiDropRater>",
            "format": ""
        },
        {
            "name": "raters_count",
            "baseName": "raters_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "context_profile_context",
            "baseName": "context_profile_context",
            "type": "ApiDropContextProfileContext",
            "format": ""
        },
        {
            "name": "subscribed_actions",
            "baseName": "subscribed_actions",
            "type": "Array<ApiDropSubscriptionTargetAction>",
            "format": ""
        },
        {
            "name": "is_signed",
            "baseName": "is_signed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "reactions",
            "baseName": "reactions",
            "type": "Array<ApiDropReaction>",
            "format": ""
        },
        {
            "name": "boosts",
            "baseName": "boosts",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "hide_link_preview",
            "baseName": "hide_link_preview",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "nft_links",
            "baseName": "nft_links",
            "type": "Array<ApiDropNftLink>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiDrop.attributeTypeMap;
    }

    public constructor() {
    }
}



